import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronRight, Lock } from 'lucide-react';
// Replace with the live Anedot hosted form URL for AZ City PAC.
const ANEDOT_URL = 'https://secure.anedot.com/az-city-pac/donate';
function formatAmount(amount: number): string {
  if (amount >= 1000000) {
    return `$${(amount / 1000000).toFixed(amount % 1000000 === 0 ? 0 : 1)}M`;
  }
  if (amount >= 1000) return `$${(amount / 1000).toFixed(0)}K`;
  return `$${amount}`;
}
export function DonateModule() {
  const [isMonthly, setIsMonthly] = useState(true);
  const [selectedAmount, setSelectedAmount] = useState<number | 'custom'>(100);
  const [customAmount, setCustomAmount] = useState('');
  const presetAmounts = [25, 50, 100, 250, 500, 1000];
  const goal = 50000;
  const raised = 1211;
  const percentComplete = raised / goal * 100;
  const handleContribute = () => {
    const amount = selectedAmount === 'custom' ? Number.parseFloat(customAmount) : selectedAmount;
    if (!amount || amount <= 0) return;
    const params = new URLSearchParams({
      amount: String(amount),
      recurring: isMonthly ? 'true' : 'false',
      recurring_duration: isMonthly ? 'monthly' : ''
    });
    window.location.href = `${ANEDOT_URL}?${params.toString()}`;
  };
  const isContributeDisabled = selectedAmount === 'custom' && (!customAmount || Number.parseFloat(customAmount) <= 0);
  return <div id="donate" className="scroll-mt-24 bg-white rounded-xl shadow-2xl overflow-hidden border border-slate-200 w-full max-w-md mx-auto" data-id="element-22" data-mp="188716sjr9omf">
      <div className="bg-slate-50 p-6 border-b border-slate-200" data-id="element-23" data-mp="1h7txizxmo48m">
        <h2 className="font-serif font-bold text-2xl text-pac-navy text-center mb-4 uppercase tracking-wide" data-id="element-24" data-mp="1h955lby3vy5j">
          Invest in Local Leadership
        </h2>

        <div className="mb-2 flex justify-between text-sm font-bold" data-id="element-25" data-mp="2sm7i9vx343kf">
          <span className="text-pac-blue" data-id="element-26" data-mp="2olno917t5g2i">
            ${raised.toLocaleString()} Raised
          </span>
          <span className="text-slate-500" data-id="element-27" data-mp="1laq92qyviu1h">Goal: ${goal.toLocaleString()}</span>
        </div>
        <div className="w-full bg-slate-200 rounded-full h-3 mb-2 overflow-hidden" data-id="element-28" data-mp="1q9b0c0w5e3ds">
          <motion.div initial={{
          width: 0
        }} animate={{
          width: `${percentComplete}%`
        }} transition={{
          duration: 1.5,
          ease: 'easeOut'
        }} className="bg-pac-gold h-3 rounded-full" data-id="element-29" data-mp="1qbdy573jl0t2" />
        </div>
        <p className="text-xs text-center text-slate-500 font-medium" data-id="element-30" data-mp="17k4pf01lig2j">
          Join 248 Arizona civic leaders today.
        </p>
      </div>

      <div className="p-6" data-id="element-31" data-mp="1bikcf3xofofy">
        <div className="flex p-1 bg-slate-100 rounded-lg mb-6" aria-label="Contribution frequency" data-id="element-32" data-mp="1gb53hxp77nfs">
          <button type="button" onClick={() => setIsMonthly(false)} aria-pressed={!isMonthly} className={`flex-1 py-2.5 text-sm font-bold rounded-md transition-all ${!isMonthly ? 'bg-white text-pac-navy shadow-sm border border-slate-200' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-33" data-mp="jsfq2zqcwrc3">
            One-Time
          </button>
          <button type="button" onClick={() => setIsMonthly(true)} aria-pressed={isMonthly} className={`flex-1 py-2.5 text-sm font-bold rounded-md transition-all ${isMonthly ? 'bg-pac-navy text-white shadow-sm' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-34" data-mp="7a3paousmkxj">
            Monthly
          </button>
        </div>

        <div className="grid grid-cols-3 gap-3 mb-4" data-id="element-35" data-mp="3opjz127p9vwk">
          {presetAmounts.map(amount => <button type="button" key={amount} onClick={() => {
          setSelectedAmount(amount);
          setCustomAmount('');
        }} aria-pressed={selectedAmount === amount} className={`py-3 rounded border-2 font-bold text-lg transition-all ${selectedAmount === amount ? 'border-pac-red bg-red-50 text-pac-red' : 'border-slate-200 text-slate-700 hover:border-pac-blue hover:text-pac-blue'}`} data-id="element-36" data-mp="3fqoq3id9u7pk">
              {formatAmount(amount)}
            </button>)}
        </div>

        <div className="mb-6" data-id="element-37" data-mp="zxglyfh9dvch">
          <label htmlFor="custom-donation" className="sr-only" data-id="element-38" data-mp="14y4bewpua44l">
            Other contribution amount
          </label>
          <div className={`relative flex items-center border-2 rounded transition-all ${selectedAmount === 'custom' ? 'border-pac-red bg-red-50' : 'border-slate-200'}`} data-id="element-39" data-mp="qxtjrrgpglid">
            <span className={`pl-4 font-bold ${selectedAmount === 'custom' ? 'text-pac-red' : 'text-slate-500'}`} data-id="element-40" data-mp="h1i7h1h47vnx">
              $
            </span>
            <input id="custom-donation" type="number" min="1" placeholder="Other Amount" value={customAmount} onChange={event => {
            setSelectedAmount('custom');
            setCustomAmount(event.target.value);
          }} onFocus={() => setSelectedAmount('custom')} className="w-full py-3 px-2 bg-transparent outline-none font-bold text-slate-700 placeholder:text-slate-400 placeholder:font-normal" data-id="element-41" data-mp="2bezl9wrpxe5r" />
          </div>
        </div>

        <button type="button" onClick={handleContribute} disabled={isContributeDisabled} className="w-full bg-pac-red hover:bg-red-800 disabled:bg-slate-300 disabled:cursor-not-allowed disabled:hover:translate-y-0 text-white py-4 rounded font-bold text-xl uppercase tracking-wider transition-all shadow-[0_4px_14px_0_rgba(185,28,28,0.39)] hover:shadow-[0_6px_20px_rgba(185,28,28,0.23)] hover:-translate-y-0.5 flex items-center justify-center gap-2 group" data-id="element-42" data-mp="9npmyqj7vh6a">
          Contribute Now
          <ChevronRight className="h-6 w-6 group-hover:translate-x-1 transition-transform" data-id="element-43" data-mp="2u7y7v6uggskp" />
        </button>

        <div className="mt-4 flex items-center justify-center gap-2 text-xs text-slate-500" data-id="element-44" data-mp="3jwc4k8fr20fh">
          <Lock className="h-3 w-3" data-id="element-45" data-mp="3nwdtri4at1dv" />
          <span data-id="element-46" data-mp="3nxfhon6exid0">Secure, encrypted transaction via Anedot</span>
        </div>
      </div>
    </div>;
}